import { useState } from 'react';
import IplHeader from "./IplHeader";
import Predict from "./Predict";
import TopStackers from "./TopStackers";
import PurchaseStreak from "./PurchaseStreak";
import { BsShareFill } from "react-icons/bs";
import FAQ from "../FAQ";
import TermsAndCondition from "../TermsAndCondition";
import * as APIHelper from '../../Helper/apiFetch';
import * as nativeEvents from '../../Helper/native';
import Powerplay from "../IPL2026/Powerplay";
const initiaData = require('../urlEncodeTest.json');

export default function IPL2026Home() {
    const [referralLink, setReferralLink] = useState(null);
    const [cardIssued, setCardIssued] = useState(null);
    const [cardPaymentStatus, setCardPaymentStatus] = useState(null);

    const handleCardData = ({ cardIssued: issued, cardPaymentStatus: paymentStatus }) => {
        setCardIssued(issued);
        setCardPaymentStatus(paymentStatus);
    };

    const shareWithFriends = () => {
        // APIHelper.postAnalytics("share_from_home");
        nativeEvents.shareReferral(null, referralLink);
    }


    return (
        <div className="campBody">
                <button className="floatingShareButtonContainer" onClick={() => shareWithFriends()}>
                    <BsShareFill size={22} color='#FFCDB3' />
                </button>
            <IplHeader />
            <div className="iplHomeContainer">
                <div className="iplHomeContainerOverlay"></div>
                <div style={{ padding: '20px 0px 20px 0px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                        <div className="rightDiv"></div>
                        <span style={{ margin: '0 10px', fontWeight: '600', fontSize: '16px' }}>PREDICT AND WIN</span>
                        <div className="leftDiv"></div>
                    </div>
                    <div style={{fontSize: '14px', fontWeight: 500, color: '#FFFFFF', marginTop: '12px'}}>
                        <span style={{ fontWeight: '600', fontSize: '16px', letterSpacing: '0px' }}>Pick the winning team — unlock a surprise <br />reward!</span>
                    </div>
                </div>
                <Predict cardIssued={cardIssued} cardPaymentStatus={cardPaymentStatus} />
                <Powerplay />
                <PurchaseStreak cardIssued={cardIssued} cardPaymentStatus={cardPaymentStatus} />
                <div style={{ display: 'flex', padding: '56px 0px 20px 0px' }}>
                    <div className="rightDiv"></div>
                    <span style={{ margin: '0 10px' }}>HIGHEST STACKER KAUN</span>
                    <div className="leftDiv"></div>
                </div>
                <TopStackers onLinkFetched={setReferralLink} onCardDataFetched={handleCardData} />
                <FAQ />
                <TermsAndCondition />
            </div>
        </div>
    )
}
